<!--
 * @Author: wsx
 * @Date: 2022-02-25 10:52:40
 * @LastEditTime: 2022-03-01 12:00:01
 * @Description: 首页左侧面板
 * @FilePath: \hz-digital-twin\src\views\Home\LeftFrame.vue
-->
<template>
  <screen-frame
    class="LeftFrame"
    body-class="left-frame-content"
    type="left"
    width="560px"
    :isShowOpenBtn="false"
  >
    <div class="h-section">
      <div class="h-section-person">
        <h-card title="人口统计">
          <div class="h-user-distribution">
            <div class="h-user-total">
              <div class="h-user-total-contetn">
                <span class="h-value">{{ userTotal }}</span>
                <span class="h-label">实有人口</span>
              </div>
            </div>
            <ul class="h-user-data">
              <li class="h-num-item">
                <i class="h-sign"></i>
                <span class="h-label">常住人口</span>
                <span class="h-value">1456</span>
              </li>
              <li class="h-num-item">
                <i class="h-sign"></i>
                <span class="h-label">流动人口</span>
                <span class="h-value">456</span>
              </li>
              <!-- <li class="h-num-item">
                <i class="h-sign"></i>
                <span class="h-label">会议厅2</span>
                <span class="h-value">456</span>
              </li> -->
            </ul>
          </div>
        </h-card>
        <h-card title="人流量统计">
          <div class="h-user-chart" ref="userChart"></div>
        </h-card>
      </div>
      <div class="h-section-person">
        <h-card title="重点人员统计">
          <div
            class="h-key-distribution"
            id="echartsbottomLeft"
            ref="keyPersonChart"
          ></div>
          <!-- <div class="h-car-distribution">
            <div class="h-car-situation">
              <div class="h-car-total">
                <span class="h-value">873</span>
              </div>
              <ul class="h-user-data">
                <li class="h-num-item">
                  <i class="h-sign"></i>
                  <span class="h-label">已用</span>
                  <span class="h-value">456</span>
                </li>
                <li class="h-num-item">
                  <i class="h-sign"></i>
                  <span class="h-label">剩余</span>
                  <span class="h-value">456</span>
                </li>
              </ul>
            </div>
            <div class="h-car-statistics">
              <div class="h-car-parkingLot">
                <div class="h-label">B1车位</div>
                <div class="h-car-chart">
                  <ul class="h-chart-legend">
                    <li>
                      <span class="legend-label">剩余：</span>
                      <span class="legend-val">{{
                        parkingLot.B1.surplus
                      }}</span>
                    </li>
                    <li>
                      <span class="legend-label">已用：</span>
                      <span class="legend-val">{{ parkingLot.B1.used }}</span>
                    </li>
                  </ul>
                  <h-progress
                    ref="progressRef1"
                    :percentage="calculationSroportion(parkingLot.B1)"
                  ></h-progress>
                </div>
              </div>
              <div class="h-car-parkingLot">
                <div class="h-label">B1车位</div>
                <div class="h-car-chart">
                  <ul class="h-chart-legend">
                    <li>
                      <span class="legend-label">剩余：</span>
                      <span class="legend-val">{{
                        parkingLot.B2.surplus
                      }}</span>
                    </li>
                    <li>
                      <span class="legend-label">已用：</span>
                      <span class="legend-val">{{ parkingLot.B2.used }}</span>
                    </li>
                  </ul>
                  <h-progress
                    ref="progressRef2"
                    :percentage="calculationSroportion(parkingLot.B2)"
                  ></h-progress>
                </div>
              </div>
            </div>
          </div> -->
        </h-card>
        <h-card title="车流量统计">
          <div class="h-user-distribution" ref="carChart"></div>
        </h-card>
      </div>
    </div>
    <h-card class="h-field-card" title="事件上报">
      <div class="h-field">
        <div class="h-field-total" ref="fieldChart"></div>
        <!-- <div class="h-field-total">
          <div class="topLeft">
            <i :class="['iconfont', 'icon-jurassic_safe']"></i>
          </div>
          <div class="topRight">
            <span class="sizeNum blueColor">78</span>
            <span>事件总量</span>
          </div>
        </div> -->
        <div class="h-field-data">
          <ul class="h-field-tabs">
            <template v-for="(item, key) in fieldDatas" :key="key">
              <li
                class="h-tab"
                :class="[{ current: currentTab === item.id }, item.class]"
                @click="clickTab(item)"
              >
                <i class="h-tab-legend"></i>
                <span class="h-tab-label">{{ item.name }}</span>
                <span class="h-tab-value">{{ item.list.length }}</span>
              </li>
            </template>
          </ul>
          <div
            class="h-field-list-box"
            @mouseenter="suspendFieldRotation"
            @mouseleave="startFieldRotation"
          >
            <div
              class="h-field-list-content"
              :style="{ left: -(currentTab - 1) * 100 + '%' }"
            >
              <template v-for="(item, key) in fieldDatas" :key="key">
                <ul
                  class="h-field-list"
                  :style="{ top: -item.top * 90 + 'px' }"
                >
                  <template v-for="item in item.list" :key="item.id">
                    <li class="h-field-item">
                      <div class="h-field-item-name">
                        <h-icon icon="icon-fangwu"></h-icon>
                        <span>{{ item.fieldName }}</span>
                      </div>
                      <div class="h-field-item-info">
                        <span class="name">{{ item.name }}</span>
                        <span>{{ item.startTime }}</span>
                      </div>
                      <div class="h-field-item-climate">
                        <div class="h-field-temperature">
                          <!-- <span class="value">{{ item.temperature }}</span>
                          <span>温度</span> -->
                        </div>
                        <div class="h-field-humidity">
                          <span class="value">{{ item.humidity }}</span>
                          <!-- <span>湿度</span> -->
                        </div>
                      </div>
                    </li>
                  </template>
                  <li class="h-tips" v-if="item.list.length === 0">暂无数据</li>
                </ul>
              </template>
            </div>
          </div>
        </div>
      </div>
    </h-card>
  </screen-frame>
</template>
<script>
import {
  defineComponent,
  reactive,
  onMounted,
  toRefs,
  nextTick,
  onUnmounted,
  ref
} from "vue";
import HProgress from "@/components/HProgress/index.vue";
import ScreenFrame from "./ScreenFrame.vue";
import * as echarts from "echarts";
import {
  personCharts,
  carCharts,
  fieldEcharts,
  keyPersonEcharts
} from "./echart";
import _ from "lodash";
export default defineComponent({
  name: "LeftFrame",
  components: { HProgress, ScreenFrame },
  setup(props) {
    const state = reactive({
      userTotal: 345,
      parkingLot: {
        B1: {
          used: 102,
          surplus: 305
        },
        B2: {
          used: 102,
          surplus: 305
        }
      },
      fieldDatas: {
        use: {
          id: 1,
          top: 0,
          name: "今日上报",
          class: "h-tab-use",
          list: [
            {
              id: 1,
              fieldName: "矛盾纠纷",
              name: "吵架",
              startTime: "文峰街道滨湖中路73号",
              // endTime: "滨湖中路73号",
              // temperature: "6℃",
              humidity: "处理中"
            }
            // {
            //   id: 2,
            //   fieldName: "多功能厅",
            //   name: "百度元宇宙会议",
            //   startTime: "5月12日",
            //   endTime: "5月15日",
            //   temperature: "6℃",
            //   humidity: "6%",
            // },
          ]
        },
        subscribe: {
          id: 2,
          top: 0,
          name: "同比",
          class: "h-tab-subscribe",
          list: []
        },
        free: {
          id: 3,
          top: 0,
          name: "环比",
          class: "h-tab-free",
          list: []
        }
      },
      currentTab: 1
    });
    const refData = toRefs(state);
    const userChart = ref();
    const carChart = ref();
    const keyPersonChart = ref();
    const fieldChart = ref();
    const progressRef1 = ref();
    const progressRef2 = ref();

    const calculationSroportion = item => {
      return (item.surplus / (item.used + item.surplus)) * 100;
    };
    // 切换tab
    const clickTab = item => {
      if (state.currentTab !== item.id) {
        item.top = 0;
        state.currentTab = item.id;
      }
    };
    let times;
    // 开始场地使用情况轮播
    const startFieldRotation = () => {
      times = setInterval(() => {
        switch (state.currentTab) {
          case 1:
            // 修改上一个tab 列表的位置
            if (
              state.fieldDatas.use.top === 0 &&
              state.fieldDatas.free.top !== 0
            ) {
              state.fieldDatas.free.top = 0;
            }
            // 切换tab
            if (
              state.fieldDatas.use.top >=
              state.fieldDatas.use.list.length - 1
            ) {
              state.currentTab = 2;
            } else {
              // 设置列表上划
              state.fieldDatas.use.top += 1;
            }
            break;
          case 2:
            if (
              state.fieldDatas.subscribe.top === 0 &&
              state.fieldDatas.use.top !== 0
            ) {
              state.fieldDatas.use.top = 0;
            }
            if (
              state.fieldDatas.subscribe.top >=
              state.fieldDatas.subscribe.list.length - 1
            ) {
              state.currentTab = 3;
            } else {
              state.fieldDatas.subscribe.top += 1;
            }
            break;
          case 3:
            if (
              state.fieldDatas.free.top === 0 &&
              state.fieldDatas.free.top !== 0
            ) {
              state.fieldDatas.subscribe.top = 0;
            }
            if (
              state.fieldDatas.free.top >=
              state.fieldDatas.free.list.length - 1
            ) {
              state.currentTab = 1;
            } else {
              state.fieldDatas.free.top += 1;
            }
            break;
        }
      }, 300000);
    };
    // 暂停场地使用情况轮播
    const suspendFieldRotation = () => {
      clearInterval(times);
    };
    // 初始化图表
    const initChart = () => {
      // 人流量统计图
      const chart = echarts.init(userChart.value);
      chart.setOption(personCharts());
      // 车流量统计图
      const carEchart = echarts.init(carChart.value);
      carEchart.setOption(carCharts());
      // 场地使用情况统计图
      const fieldEchartDom = echarts.init(fieldChart.value);
      fieldEchartDom.setOption(fieldEcharts());
      // 定时重新渲染图表
      const fn = () => {
        _.delay(function() {
          chart.clear();
          chart.clear();
          fieldEchartDom.clear();
          // progressRef1.value.refresh();
          // progressRef2.value.refresh();
          nextTick(() => {
            chart.setOption(personCharts());
            carEchart.setOption(carCharts());
            fieldEchartDom.setOption(fieldEcharts());
          });
          fn();
        }, 5000);
      };
      fn();
    };
    let mykeyPersonEchartresize;
    // 重点人员统计
    const mykeyPersonEchart = () => {
      const keyPersonEchart = (mykeyPersonEchartresize = echarts.init(
        document.getElementById("echartsbottomLeft")
      ));
      keyPersonEchart.setOption(keyPersonEcharts());
    };
    onMounted(() => {
      initChart();
      // startFieldRotation();
      mykeyPersonEchart();
      window.addEventListener("resize", () => {
        mykeyPersonEchartresize.resize();
      });
    });
    onUnmounted(() => {
      suspendFieldRotation();
    });
    return {
      ...refData,
      clickTab,
      carChart,
      userChart,
      keyPersonChart,
      fieldChart,
      // progressRef1,
      // progressRef2,
      calculationSroportion,
      suspendFieldRotation,
      startFieldRotation
    };
  }
});
</script>
<style lang="scss" scoped>
@import "@/assets/utils.scss";
.LeftFrame {
  .HCard {
    background-color: #0000;
    /deep/.HTitle {
      color: #cb8847;
    }
  }
  :deep(.left-frame-content) {
    display: flex;
    flex-direction: column;
  }
  .h-section {
    display: grid;
    grid-template-columns: repeat(2, calc(50% - 5px));
    grid-column-gap: 10px;
  }
  .h-num-item {
    @include flex-row-s-c;
    .h-sign {
      margin-right: 10px;
      display: flex;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #be8a63;
      border: 1px solid #cb8847;
      @include flex-row-c-c;
      &::after {
        content: "";
        background-color: #fff;
        width: 2px;
        height: 2px;
      }
    }
    .h-label {
      display: inline-block;
      width: 70px;
      color: #91c8ff;
    }
    .h-value {
      flex: 1;
      font-family: "YouSheBiaoTiHei";
      font-size: 20px;
    }
  }
  $cardHeight: 160px;
  .h-user-distribution {
    height: $cardHeight;
    @include flex-row-sb-c;
    .h-user-total {
      width: 105px;
      height: 99px;
      margin: 10px 0;
      position: relative;
      &::before {
        width: 100%;
        height: 0;
        padding-top: 100%;
        animation-name: ARotateReverse;
        background-image: url("~@/assets/images/index/circle.png");
      }
      &::after {
        width: 90%;
        height: 0;
        padding-top: 90%;
        animation-name: ARotate;
        background-image: url("~@/assets/images/index/circle1.png");
      }
      &::after,
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        animation-duration: 7s;
        background-size: 100% 100%;
        z-index: 1;
      }
      .h-user-total-contetn {
        position: relative;
        z-index: 2;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding-bottom: 10px;
        color: #62f562;
        @include flex-col-c-c;
        .h-value {
          font-size: 16px;
        }
      }
    }
    .h-user-data {
      flex: 1;
      margin-top: 15px;

      $colors: #8decf4, #ffb803, #198afe;
      @each $c in $colors {
        $i: index($colors, $c);
        .h-num-item:nth-child(#{$i}) .h-value {
          color: $c;
        }
      }
    }
  }
  .h-key-distribution {
    width: 100%;
    height: 160px;
  }
  .h-car-distribution {
    height: $cardHeight;
    @include flex-col-se-c;
    .h-car-situation {
      width: 100%;
      height: 65px;
      @include flex-row-s-c;
      .h-car-total {
        width: 65px;
        height: 65px;
        font-size: 14px;
        margin: 0 12px;
        background-image: url("~@/assets/images/index/carTotal.png");
        @include flex-row-c-c;
      }
      $colors: #fff, #91c8ff, #198afe;
      @each $c in $colors {
        $i: index($colors, $c);
        .h-num-item:nth-child(#{$i}) {
          .h-label {
            color: $c;
          }
          .h-value {
            color: $c;
          }
        }
      }
    }
    .h-car-statistics {
      width: 100%;
      @include flex-col-s-s;
      .h-car-parkingLot {
        width: 100%;
        height: 40px;
        font-size: 14px;
        @include flex-row-s-e;
        .h-car-chart {
          flex: 1;
          height: 100%;
          margin-left: 10px;
          @include flex-col-sb-s;
          .h-chart-legend {
            width: 100%;
            @include flex-row-sb-s;
            .legend-label {
              color: #91c8ff;
            }
          }
        }
      }
    }
  }
  .h-user-chart {
    height: $cardHeight;
  }
  .h-field-card {
    flex: 1;
    overflow: hidden;
  }
  .h-field {
    height: 100%;
    @include flex-row-s-s;
    .h-field-total {
      height: 100%;
      width: 33%;
      @include flex-row-c-c;
      color: #fff;
      .topLeft {
        width: 58px;
        height: 57px;
        margin-right: 10px;
        text-align: center;
        line-height: 57px;
        background-image: url("~@/assets/images/home/yuan.png");
        background-size: cover;
      }
      .topRight {
        display: flex;
        flex-direction: column;

        .sizeNum {
          font-size: 20px;
          margin-bottom: 5px;
          color: #73f1f3;
        }
      }
    }
    .h-field-data {
      flex: 1;
      height: 100%;
      @include flex-col-s-s;
      .h-field-tabs {
        width: 100%;
        height: 34px;
        box-sizing: border-box;
        padding-left: 10px;
        @include flex-row-sb-c;
        .h-tab {
          width: calc(100% / 3);
          box-sizing: border-box;
          padding-right: 15px;
          @include flex-row-s-c;
          $tabs: (h-tab-use, #14e7d8), (h-tab-subscribe, #91c8ff),
            (h-tab-free, #e2deba);
          @each $tab, $color in $tabs {
            &.#{$tab} {
              color: $color;
              .h-tab-legend {
                background-color: $color;
              }
            }
          }
          &.current {
            transform: scale(1.3);
            transform-origin: left;
          }
          .h-tab-legend {
            width: 10px;
            height: 10px;
            border-radius: 50%;
          }
          .h-tab-label {
            padding: 0 5px;
          }
          .h-tab-value {
            font-size: 20px;
            font-family: "YouSheBiaoTiHei";
          }
        }
        :nth-child(1) {
          width: 50%;
        }
      }
      .h-field-list-box {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        position: relative;
        .h-field-list-content {
          position: absolute;
          height: 100%;
          width: 300%;
          overflow: hidden;
          transition: all 0.3s;
          @include flex-row-s-s;
          .h-field-list {
            transition: all 0.5s;
            position: relative;
            width: calc(100% / 3);
            .h-tips {
              width: 100%;
              text-align: center;
              margin-top: 30px;
              font-size: 24px;
              color: #e2e2e2;
              opacity: 0.6;
            }
            .h-field-item {
              height: 90px;
              padding-left: 10px;
              background-image: url("~@/assets/images/index/fieldItemBg.png");
              background-size: 100% 100%;
              @include flex-row-se-c;
              .h-field-item-name {
                width: 80px;
                @include flex-col-c-c;
              }
              .h-field-item-info {
                font-weight: bold;
                font-size: 16px;
                @include flex-col-c-s;
                .name {
                  color: #07bce5;
                  font-size: 16px;
                }
              }
              .h-field-item-climate {
                @include flex-row-c-c;
                & > div {
                  width: 52px;
                  height: 52px;
                  background-size: 100% 100%;
                  @include flex-col-c-c;
                  &.h-field-temperature {
                    background-image: url("~@/assets/images/index/circle2.png");
                    margin-right: 5px;
                    .value {
                      color: #e6b123;
                    }
                  }
                  &.h-field-humidity {
                    background-image: url("~@/assets/images/index/circle3.png");
                    .value {
                      color: #23e6d1;
                      font-size: 12px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@keyframes ARotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes ARotateReverse {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>
